export default __webpack_public_path__ + "static/media/emptySchedule.345a27ad.svg";